import axios from 'axios';

const api = axios.create({
  baseURL: 'https://automais.pro/api'
});

api.interceptors.request.use(config => {
  // Rotas /master/* usam a sessão própria do painel (master_token), nunca o token do tenant —
  // senão, com uma loja logada no mesmo navegador, o master leva 401 e entra em loop de login.
  const isMaster = (config.url || '').startsWith('/master/');
  const token = localStorage.getItem(isMaster ? 'master_token' : 'token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    // Empresa suspensa (inadimplência/desativada): qualquer rota do tenant cai na tela de bloqueio.
    if (err.response?.status === 403 && err.response.data?.code === 'EMPRESA_SUSPENSA'
        && !(err.config?.url || '').startsWith('/master/')) {
      if (window.location.pathname !== '/suspenso') window.location.href = '/suspenso';
      return Promise.reject(err);
    }
    if (err.response?.status === 401) {
      // Painel master tem sessão própria (master_token): não derruba a sessão do tenant nem vai pro /login.
      // 401 no /master/login = credencial errada → deixa o Master.js mostrar o erro.
      const url = err.config?.url || '';
      if (url.startsWith('/master/')) {
        if (url !== '/master/login') {
          localStorage.removeItem('master_token');
          window.location.href = '/master';
        }
        return Promise.reject(err);
      }
      localStorage.removeItem('token');
      localStorage.removeItem('impersonacao');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
